goog.provide("shadow.js.shim.module$ol$interaction$Select_js$default");
shadow.js.shim.module$ol$interaction$Select_js$default = shadow.js.require(273, {}).default;
